import React from 'react';

const PALETTE = [
  '#1a1a2e', '#0f4c75', '#0f172a', '#134e4a', '#1e3a5f',
  '#7C3AED', '#2563EB', '#059669', '#b91c1c', '#0369a1',
  '#8c6239', '#92400e', '#9c4221', '#b45309', '#6b5c3e',
];

const FONTS = [
  'Inter', 'Roboto', 'Open Sans', 'Lato', 'Montserrat',
  'Merriweather', 'Playfair Display', 'Lora', 'PT Serif', 'Nunito'
];

export default function CustomizePanel({
  accentColor,
  setAccentColor,
  fontScale,
  setFontScale,
  fontFamily,
  setFontFamily,
  T,
}) {
  return (
    <div style={{
      borderTop: `1px solid ${T.borderMain}`,
      background: T.customizeBg,
      padding: '16px 20px 18px',
    }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 20 }}>
        {/* Colors */}
        <div>
          <p style={{
            fontSize: '8.5px',
            fontWeight: 800,
            color: T.textMuted,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            margin: '0 0 10px',
          }}>Accent Color</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 6 }}>
            {PALETTE.map(c => (
              <button
                key={c}
                onClick={() => setAccentColor(c)}
                title={c}
                style={{
                  width: '100%',
                  aspectRatio: '1',
                  borderRadius: 8,
                  background: c,
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  boxShadow: accentColor === c
                    ? `0 0 0 2.5px ${T.pageBg}, 0 0 0 4.5px ${c}`
                    : '0 1px 3px rgba(0,0,0,0.2)',
                  transform: accentColor === c ? 'scale(1.2)' : 'scale(1)',
                  transition: 'all 0.18s',
                }}
              />
            ))}
          </div>
        </div>

        {/* Font */}
        <div>
          <p style={{
            fontSize: '8.5px',
            fontWeight: 800,
            color: T.textMuted,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            margin: '0 0 10px',
          }}>Font Family</p>
          <select
            value={fontFamily}
            onChange={e => setFontFamily?.(e.target.value)}
            style={{
              width: '100%',
              padding: '8px 10px',
              borderRadius: 8,
              background: T.inputBg,
              border: `1px solid ${T.inputBorder}`,
              color: T.inputColor,
              fontSize: 10.5,
              outline: 'none',
              cursor: 'pointer',
            }}
          >
            {FONTS.map(f => (
              <option key={f} value={f} style={{ background: T.isDark ? '#1e293b' : '#fff' }}>
                {f}
              </option>
            ))}
          </select>
        </div>

        {/* Size */}
        <div>
          <p style={{
            fontSize: '8.5px',
            fontWeight: 800,
            color: T.textMuted,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            margin: '0 0 10px',
          }}>
            Font Size <span style={{ color: T.textSecondary, fontWeight: 600 }}>{Math.round(fontScale * 100)}%</span>
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 5, marginBottom: 8 }}>
            {[
              { l: 'S', v: 0.85 },
              { l: 'M', v: 1 },
              { l: 'L', v: 1.12 },
              { l: 'XL', v: 1.25 },
            ].map(({ l, v }) => (
              <button
                key={l}
                onClick={() => setFontScale?.(v)}
                style={{
                  padding: '6px 0',
                  borderRadius: 7,
                  fontSize: 9.5,
                  fontWeight: 700,
                  cursor: 'pointer',
                  border: 'none',
                  background: Math.abs(fontScale - v) < 0.04 ? accentColor : T.pillBg,
                  color: Math.abs(fontScale - v) < 0.04 ? 'white' : T.textMuted,
                  transition: 'all 0.15s',
                }}
              >
                {l}
              </button>
            ))}
          </div>
          <input
            type="range"
            min="0.75"
            max="1.3"
            step="0.01"
            value={fontScale}
            onChange={e => setFontScale?.(parseFloat(e.target.value))}
            style={{ width: '100%', cursor: 'pointer', accentColor }}
          />
        </div>
      </div>
    </div>
  );
}
